import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL,
    prepareHeaders: headers => {
        const token = window.localStorage.getItem('authToken')
        headers.set('Authorization', `Bearer ${token}`)
        return headers
    },
})

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery,
    refetchOnMountOrArgChange: true,
    tagTypes: [
        'me',
        'service',
        'tenantUser',
        'teamManagement',
        'workGroups',
        'chats',
        'customers',
    ],
    endpoints: builder => ({}),
})
